import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ebenchLogo from "../images/ebench_logo.png";
import {
  ForgotPassword,
  VerifyResetOtpAction,
} from "../Redux/action/AuthAction";

const VerifyResetOtp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [isResendVisible, setIsResendVisible] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const email = state?.email;
  const userType = state?.userType;

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return; // Only allow digits and empty

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fullOtp = otp.join("");

    if (fullOtp.length !== 6) {
      toast.error("Please enter the complete 6-digit OTP.", { toastId: "resetpassError" });
      return;
    }

    const data = {
      otp: fullOtp,
      email,
      userType,
    };

    dispatch(VerifyResetOtpAction(data))
      .then((res) => {
        console.log("rsrs", res?.data)
        if (res?.data) {
          setTimeout(() => {
            navigate("/new-password", { state: { candidateId: res?.data?.candidateId, vendorId: res?.data?.vendorId, userType: res?.data?.userType } });
          }, 1000);
        }
      })
      .catch(() => {
        // toast.error("Invalid OTP. Please try again.");
      });
  };

  useEffect(() => {
    let timer;
    if (secondsLeft > 0) {
      setIsResendVisible(false);
      timer = setInterval(() => {
        setSecondsLeft((prev) => prev - 1);
      }, 1000);
    } else {
      setIsResendVisible(true);
    }

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const handleResendOtp = () => {
    setIsLoading(true);
    dispatch(ForgotPassword({ email, userType }))
      .then((res) => {
        if (res?.data) {
          setSecondsLeft(60);
        }
      })
      .catch(() => {
        toast.error("Failed to resend OTP.", { toastId: "resetpassError" });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <ToastContainer />
      <div className="otp_ver_wrapper">
        <div className="otp_ver_container">
          <header
            className="d-flex justify-content-between align-items-center px-5 py-3 shadow-sm"
            style={{ backgroundColor: "#fff" }}
          >
            {/* Logo */}
            <div className="landing_logo">
              <Link to="/">
                <img
                  src={ebenchLogo}
                  alt="Ebench Logo"
                  className="responsive-logo-of-without-login"
                />
              </Link>
            </div>
          </header>

          <div
            style={{
              minWidth: "100%",
              height: "90vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow: "2px 2px 19px rgba(0, 0, 0, 0.2)",
                padding: "20px",
              }}
            >
              <h4 className="text_center" style={{ marginBottom: "40px" }}>
                Enter Verification OTP
              </h4>
              <form
                onSubmit={handleSubmit}
                className="d-flex align-items-center flex-column"
              >
                <p style={{ marginBottom: "10px" }}>
                  Type your 6 digit security code
                </p>
                <div className="d-flex gap-2">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      className="otp-box"
                      style={{
                        fontSize: "20px",
                        width: "40px",
                        height: "40px",
                        textAlign: "center",
                      }}
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                    />
                  ))}
                </div>
                <div className="form-group mt-4 reg verify_button">
                  <Button
                    type="submit"
                    style={{
                      padding: "10px 27px",
                      background: "#286a94",
                      marginTop: "12px",
                    }}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </div>
                <div>
                  {isResendVisible ? (
                    <div style={{ marginTop: "10px" }}>
                      Didn’t get the code?{" "}
                      <Button
                        onClick={handleResendOtp}
                        disabled={isLoading}
                        variant="text"
                      >
                        {isLoading ? "Resending..." : "Resend OTP"}
                      </Button>
                    </div>
                  ) : (
                    <p style={{ marginTop: "10px" }}>
                      Resend OTP in <strong>{secondsLeft}s</strong>
                    </p>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyResetOtp;
